import { Component, EventEmitter, Injector, OnInit, Output } from '@angular/core';
import { AppConstants } from '@app/@core/entities/app-constants';
import { AlertService } from '@app/@core/services/alert.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ChatService } from '../@core/services/chat.service';
import { UserService } from '@app/pages/rbac/users/user.service';
import { LocalService } from '@core/services/local.service';

@Component({
  standalone: false,
  selector: 'app-new-user',
  templateUrl: './new-user.component.html',
  styleUrls: ['./new-user.component.scss']
})
export class NewUserComponent implements OnInit {
  @Output() selectedNewUser = new EventEmitter();
  updateGrid: any;
  totalcount = 0;
  tableColumns: any[];
  chatService: ChatService;
  alertService: AlertService;
  chatUsers: any;
  selectedUser: any;
  userService: UserService;
  orgId: number;
  localService: LocalService;
  userId: number;

  constructor(injector: Injector, private modalService: NgbModal) {
    this.chatService = injector.get<ChatService>(ChatService);
    this.alertService = injector.get<AlertService>(AlertService);
    this.userService = injector.get<UserService>(UserService);
    this.localService = injector.get<LocalService>(LocalService);
    this.orgId = Number(this.localService.getItem('orgid') || 0);
    this.userId = Number(this.localService.getItem('id'));
  }

  ngOnInit(): void {
    this.setGridColumns();
    this.getAllChatUsersList();
  }

  getAllChatUsersList() {
    this.userService.getAllUserOrgList(this.orgId).subscribe(
      (res: any) => {
        this.chatUsers = res.data
          .filter(chatUsers => chatUsers.id !== this.userId)
          .map(user => ({
            ...user,
            fullname: user.firstname + ' ' + user.lastname
          }));
        this.totalcount = this.chatUsers.length ? this.chatUsers.length : 0;
      },
      _error => this.alertService.error(AppConstants.errorMessage)
    );
  }

  setGridColumns() {
    this.tableColumns = [
      {
        columnDef: 'fullname',
        header: 'Name',
        cell: (element: any) => `${element.fullname}`,
        dateFormat: false,
        icon: false,
        filter: true,
        link: false,
        sort: true,
        hide: false,
        fixed: false,
        Choosable: false,
        visible: false,
        selected: ['filter']
      },
      {
        columnDef: 'username',
        header: 'UserName',
        cell: (element: any) => `${element.username}`,
        dateFormat: false,
        icon: false,
        filter: true,
        link: false,
        sort: true,
        hide: false,
        fixed: false,
        Choosable: false,
        visible: false,
        selected: ['filter']
      },
      {
        columnDef: 'email',
        header: 'Email',
        cell: (element: any) => `${element.email}`,
        dateFormat: false,
        icon: false,
        filter: true,
        link: false,
        sort: true,
        hide: false,
        fixed: false,
        Choosable: false,
        visible: false,
        selected: ['filter']
      }
    ];
    this.updateGrid = {
      edit: false,
      view: false,
      lock: false,
      duplicate: false,
      delete: false,
      externalLink: false,
      outcome: true,
      rowSelection: true
    };
  }

  startNewChat() {
    this.selectedNewUser.emit(this.selectedUser);
    this.modalService.dismissAll();
  }

  getSelectedData(event) {
    this.selectedUser = event.data;
  }
}
